import { render, staticRenderFns } from "./CreateEmail.vue?vue&type=template&id=74b85166&scoped=true"
import script from "./CreateEmail.vue?vue&type=script&lang=js"
export * from "./CreateEmail.vue?vue&type=script&lang=js"
import style0 from "./CreateEmail.vue?vue&type=style&index=0&id=74b85166&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b85166",
  null
  
)

export default component.exports